<template>
  <el-dialog width="85%" :visible.sync="showSpecialtiesModal" :before-close="applySpecialtyModal" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="Select Ambulatory Specialties and Assign Records" @open="saveDisabled = true">
    <el-form>
      <el-row :gutter="10">
        <el-col :span="15">
          <el-row id="ambulatorySpecialties">
            <el-col :span="8" v-for="i in [1, 2, 3]" :key="i">
              <span v-for="s in specialtiesOrdered.slice((i - 1) * 10, i * 10)" :key="s.specialtyId">
                <h4 v-if="s.specialty === 'Other'" class="heading" style="margin-right: 30px; margin-bottom: 5px; padding-bottom: 4px;">Not Listed</h4>
                <el-form-item> <input type="checkbox" @click="toggleAmbRecord(s)" v-model="s.selected" />{{ s.specialty }} </el-form-item>
              </span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="9" style="min-height: 300px; border-left: 1px solid #ccc; ">
          <el-alert style=" width: 100%; margin-bottom: 5px;" type="warning" v-if="!specialties.some(x => x.selected === true)" :closable="false">Please select at least 1 Specialty </el-alert>
          <el-alert style=" width: 100%; margin-bottom: 5px;" type="warning" v-if="specialtiesModalMessage && specialties.some(x => x.selected === true && !x.chartCount)" :closable="false"> {{ specialtiesModalMessage }}</el-alert>
          <el-collapse id="ambCollapse" v-model="activeNames" v-show="specialties.some(x => x.selected === true)">
            <el-collapse-item v-for="s in specialtiesOrdered.filter(x => x.selected === true)" :key="s.specialtyId" :name="s.specialtyId">
              <template slot="title">
                <el-col :span="12">
                  {{ s.specialty }}
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{ (s.chartCount || 0) > 0 ? `${s.chartCount} Records` : '' }}
                </el-col>
              </template>
              <el-row :gutter="3" style="margin: 0px 0px 0px 20px;height: 190px;">
                <el-col :span="24">
                  <strong>Assign Records</strong>
                  <el-form-item label="Number of charts:">
                    <el-input-number size="mini" v-model="s.chartCount" :min="0"> </el-input-number>
                  </el-form-item>
                  <el-form-item label="Other Instructions" class="otherInstructions">
                    <el-input type="textarea" :rows="4" placeholder="Other Instructions" v-model="s.otherInstructions"> </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
          <p class="totalRecords">Total Records: {{ getTotalSpecialtyCount() }}</p>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="cancelModal">Cancel</el-button>
      <el-button :disabled="!specialties.some(x => x.selected === true)" type="primary" @click="applySpecialtyModal"> Apply</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    showSpecialtiesModal: {
      type: Boolean,
      required: true
    },
    specialties: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      specialtiesModalMessage: '',
      saveDisabled: true,
      activeNames: []
    }
  },
  computed: {
    specialtiesOrdered() {
      const list = this.specialties || []
      const rest = []
      const other = []
      for (const s of list) {
        if (s.specialty === 'Other') other.push(s)
        else rest.push(s)
      }
      return rest.concat(other)
    }
  },
  methods: {
    cancelModal() {
      this.specialtiesModalMessage = ''
      this.$emit('cancel')
    },
    toggleAmbRecord(row) {
      this.$nextTick(() => {
        if (row.selected) {
          this.activeNames.push(row.specialtyId)
          this.ieSpecialtiesHack()
        } else {
          let idx = this.activeNames.findIndex(x => x === row.specialtyId)
          if (idx >= 0) {
            this.activeNames.splice(idx, 1)
          }
          row.chartCount = 0
          row.otherInstructions = null
          row.selected = false
        }
      })
    },
    ieSpecialtiesHack() {
      let ua = window.navigator.userAgent
      if (ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            const el = document.querySelector('#ambCollapse .el-form-item')
            if (el) el.style.height = '51px'
          }, 400)
        })
      }
    },
    applySpecialtyModal() {
      if (this.specialties.some(x => x.selected && !(x.chartCount > 0))) {
        this.specialtiesModalMessage = 'Please set number of charts for all selected specialties'
        return
      }

      this.specialtiesModalMessage = ''
      this.activeNames = []
      this.$emit('apply', this.specialties.filter(x => x.selected === true))
    },
    getTotalSpecialtyCount() {
      let selected = this.specialties.filter(x => x.selected)
      let specialtyCount = 0
      for (let i = 0; i < selected.length; i++) {
        specialtyCount += selected[i].chartCount || 0
      }
      return specialtyCount
    }
  }
}
</script>

<style>
#ambulatorySpecialties >>> .el-form-item {
  margin-bottom: 10px;
}

#ambCollapse {
  border-top: 1px solid #b4bccc;
  border-bottom: 1px solid #b4bccc;
}

#ambCollapse .el-collapse-item__header {
  height: 30px !important;
  line-height: 30px !important;
  padding-left: 10px;
  border-bottom: 1px solid #b4bccc;
  color: #606266;
  font-weight: 500;
  background: #ffffff !important;
}

#ambCollapse .el-collapse-item__header:hover {
  background-color: rgb(238, 238, 238) !important;
}

#ambCollapse .el-collapse-item.is-active .el-collapse-item__header {
  background-color: rgb(238, 238, 238) !important;
}

#ambCollapse .el-collapse-item.is-active div[aria-controls*='el-collapse-content-'] {
  background-color: rgb(238, 238, 238) !important;
}

#ambCollapse .el-form-item {
  padding: 0px 0px 15px 0px;
  height: 50px;
}

.totalRecords {
  text-align: right;
  padding-right: 20px;
  font-size: 14px;
}

.otherInstructions {
  font-weight: bold;
  color: #303133 !important;
}
</style>
